const images = {
  portrait: "/assets/hardcastle/jason-hardcastle-portrait.jpg",
  logo: "/assets/hardcastle/hardcastle-d6-logo.jpg",
  districtMap: "/assets/hardcastle/district-6-map.png",
};

const serviceRoles = [
  "Former Galveston City Councilperson for District 4 from 2018 to 2020.",
  "Park Board of Trustees appointee since 2021 and chair since 2023.",
  "Active member of civic, business, library, ministry, and philanthropic boards across Galveston.",
];

const priorities = [
  {
    title: "Experience",
    body: "Jason brings direct city council experience, Park Board leadership, and a working knowledge of the industries and neighborhoods that make Galveston special.",
  },
  {
    title: "Leadership",
    body: "His campaign is grounded in practical service: showing up, listening carefully, and making decisions with District 6 residents in mind.",
  },
  {
    title: "Community",
    body: "Jason and Hayley are raising their three daughters on the island and remain deeply involved in the civic and philanthropic life of Galveston.",
  },
];

function AboutJasonPage() {
  return (
    <main className="bg-white">
      <section className="bg-[#f7f1e6] px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div className="relative">
            <div className="absolute -left-4 -top-4 size-full rounded-[2rem] bg-[#0b2f58]" />
            <img src={images.portrait} alt="Jason Hardcastle" className="relative z-10 w-full rounded-[2rem] border-8 border-white object-cover shadow-2xl" />
          </div>
          <div>
            <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">Meet Jason Hardcastle</p>
            <h1 className="mt-3 text-5xl font-bold leading-tight text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
              Proven service for Galveston District 6.
            </h1>
            <div className="mt-7 space-y-5 text-lg leading-8 text-[#37516a]">
              <p>
                Jason Hardcastle is running for Galveston City Council, this time for District 6&apos;s seat. He brings a depth of leadership and experience to this endeavor, including previously serving as a Councilperson for District 4 from 2018 to 2020.
              </p>
              <p>
                After that tenure he was appointed by the Council to the Park Board of Trustees in 2021, where he has served as the Chair since 2023. His term expires this year, and he is ready to represent the district he has lived in for the last five years.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <h2 className="text-4xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
              A lifetime of work and giving back on the island.
            </h2>
            <div className="mt-7 space-y-5 text-lg leading-8 text-[#37516a]">
              <p>
                Mr. Hardcastle brings a wealth of knowledge about Galveston and the industries that keep the community special. He has called Galveston home for more than 20 years and he and his wife Hayley are raising their three daughters, all born on the island, to appreciate Galveston&apos;s rich heritage and diversity.
              </p>
              <p>
                Jason is a wealth advisor for G Squared Private Wealth. Before that, he worked locally for Edward Jones for more than four years and in various capacities at UTMB for 13 years.
              </p>
              <p>
                With a passion to build a stronger community, Jason has served in many capacities along with his commitments to City Council and Park Board.
              </p>
              <p>
                He is currently active with the Galveston Island Rotary Club, Galveston Regional Chamber of Commerce, Galveston Economic Development Partnership, Industrial Development Corporation, Galveston Urban Ministries Board of Directors, Knights of Momus Board of Directors, Galveston College Foundation Board of Directors, and the Rosenberg Library Board of Directors and Trustees.
              </p>
              <p>
                Jason has spent his entire adult life working in and giving back to the Galveston community, and he is honored to now be a District 6 constituent pursuing this next step in his service to the island.
              </p>
            </div>
          </div>

          <aside className="rounded-[2rem] bg-[#08213d] p-8 text-white shadow-xl">
            <img src={images.logo} alt="Jason Hardcastle campaign logo" className="rounded-2xl bg-white p-4" />
            <h3 className="mt-8 text-2xl font-black">Service snapshot</h3>
            <ul className="mt-5 space-y-4">
              {serviceRoles.map((role) => (
                <li key={role} className="rounded-2xl bg-white/10 p-4 leading-7 text-white/85">
                  {role}
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </section>

      <section className="bg-[#f7f1e6] px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">The work ahead</p>
          <h2 className="mt-3 text-4xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
            Experience, leadership, and community at the center.
          </h2>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {priorities.map((priority) => (
              <div key={priority.title} className="rounded-[1.75rem] bg-white p-7 shadow-lg">
                <h3 className="text-2xl font-black text-[#08213d]">{priority.title}</h3>
                <p className="mt-4 leading-7 text-[#37516a]">{priority.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 rounded-[2rem] bg-white p-8 shadow-xl ring-1 ring-black/5 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <img src={images.districtMap} alt="Galveston District 6 map" className="rounded-3xl bg-[#f7f1e6] object-cover" />
          <div>
            <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">District 6</p>
            <h2 className="mt-3 text-4xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
              Representing the stretch from Harve Lafitte to the West End.
            </h2>
            <p className="mt-5 text-lg leading-8 text-[#37516a]">
              The campaign uses maps as a helpful guide, but voters should always verify their district and precinct through Galveston Votes before heading to the polls.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AboutJasonPage;
